import { StepConnector, stepConnectorClasses, StepIconProps, styled } from "@mui/material";
import CheckIcon from '@mui/icons-material/Check';
import SettingsIcon from "@mui/icons-material/Settings";
import PersonAddAlt1Icon from '@mui/icons-material/PersonAddAlt1';
import EngineeringIcon from '@mui/icons-material/Engineering';
import SummarizeIcon from '@mui/icons-material/Summarize';
import HourglassEmptyIcon from '@mui/icons-material/HourglassEmpty';
import DataUsageIcon from '@mui/icons-material/DataUsage';
export function ProjectProgressStepper(props: StepIconProps) {
    const { active, completed, className } = props;

    const icons: { [index: string]: React.ReactElement<unknown> } = {
        1: <HourglassEmptyIcon/>,
        2: <DataUsageIcon />,
        3: <CheckIcon />,
      };
    return (
      <ColorlibStepIconRoot ownerState={{ completed, active }} className={className}>
        <>
        {completed ? (
            <CheckIcon fontSize="medium" />
          ) : (
            icons[String(props.icon)] 
          )}
        </>
  
      </ColorlibStepIconRoot>
    );
  }

export function CreateProjectStepper(props: StepIconProps) {
    const { active, completed, className } = props;

    const icons: { [index: string]: React.ReactElement<unknown> } = {
        1: <SettingsIcon/>,
        2: <PersonAddAlt1Icon />,
        3: <EngineeringIcon />,
        4: <SummarizeIcon/>
      };
    return (
      <ColorlibStepIconRoot ownerState={{ completed, active }} className={className}>
        <>
        {completed ? (
            <CheckIcon fontSize="medium" />
          ) : (
            icons[String(props.icon)] 
          )}
        </>
  
      </ColorlibStepIconRoot>
    );
  }
  export const CustomStepConnector = styled(StepConnector)(({ theme }) => ({
    [`&.${stepConnectorClasses.alternativeLabel}`]: {
      top: 22,
    },
    [`&.${stepConnectorClasses.active}`]: {
      [`& .${stepConnectorClasses.line}`]: {
        backgroundImage: `linear-gradient(95deg, ${theme.palette.primary.main} 0%, ${theme.palette.primary.main} 50%, ${theme.palette.primary.main} 100%)`,
      },
    },
    [`&.${stepConnectorClasses.completed}`]: {
      [`& .${stepConnectorClasses.line}`]: {
        backgroundImage: `linear-gradient(95deg, ${theme.palette.primary.main} 0%, ${theme.palette.primary.main} 50%, ${theme.palette.primary.main} 100%)`,
      },
    },
    [`& .${stepConnectorClasses.line}`]: {
      height: 3,
      border: 0,
      backgroundColor:
        theme.palette.mode === "light" ? "#eaeaf0" : theme.palette.grey[800],
      borderRadius: 1,
    },
  }));
  
  const ColorlibStepIconRoot = styled('div')<{
    ownerState: { completed?: boolean; active?: boolean };
  }>(({ theme }) => ({
    backgroundColor:"rgba(201, 201, 201, 0.2)",
    zIndex: 1,
    width: 50,
    height: 50,
    display: 'flex',
    borderRadius: '50%',
    justifyContent: 'center',
    alignItems: 'center',
    ...theme.applyStyles('dark', {
      backgroundColor: theme.palette.grey[700],
    }),
    variants: [
      {
        props: ({ ownerState }) => ownerState.active,
        style: {
          backgroundImage:
            `linear-gradient( 136deg, ${theme.palette.primary.main} 0%, ${theme.palette.primary.main} 50%, ${theme.palette.primary.main} 100%)`,
          boxShadow: '0 4px 10px 0 rgba(0,0,0,.25)',
        },
      },
      {
        props: ({ ownerState }) => ownerState.completed,
        style: {
          backgroundImage:
          `linear-gradient( 136deg, ${theme.palette.primary.main} 0%, ${theme.palette.primary.main} 50%, ${theme.palette.primary.main} 100%)`,
        },
      },
    ],
  }));